export default __webpack_public_path__ + "static/media/blogcard12.4f895899.png";